import { render, staticRenderFns } from "./PartSearchTilesSkeleton.vue?vue&type=template&id=60a41ca0&scoped=true"
import script from "./PartSearchTilesSkeleton.ts?vue&type=script&lang=ts&external"
export * from "./PartSearchTilesSkeleton.ts?vue&type=script&lang=ts&external"
import style0 from "./PartSearchTilesSkeleton.scss?vue&type=style&index=0&id=60a41ca0&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a41ca0",
  null
  
)

export default component.exports